import { Helmet } from "react-helmet-async";

function MetaDecorator({ titulo, descripcion, subtitulo, url, canonical }) {
  return (
    <Helmet>
      <title>{titulo}</title>
      <meta name="title" content={subtitulo} />
      <meta name="description" content={descripcion} />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}

export default MetaDecorator;
